/**
 * Get container HTML element for react-laag.
 *
 * @param id string
 * @returns HTMLElement | undefined
 */var getContainer = function getContainer(id) {
  if (typeof window === 'undefined') return undefined;
  var container = document.querySelector("#".concat(id));
  return container || undefined;
};
export { getContainer };